import Vue from 'vue'
import VueResource from "vue-resource";
import '@/plugins/vuetify'
import store from "@/vuex/Store";
import App from '@/App.vue'
import "../src/assets/flaticon/flaticon.css";
import router from "@/router/index";
import '@/assets/stylus/main.styl';
import { clearLocalStorage } from "@/providers/RoloProvider";
import { globalData } from "@/providers/global";

Vue.use(VueResource);
Vue.config.productionTip = false;
Vue.use(require('vue-shortkey'));


Vue.http.interceptors.push(req => {
    // console.log(req)
    var token = localStorage.getItem("token");
    if (token) {
        req.headers.set("Authorization", "Bearer " + token);
    }
    
    req.headers.set("Device-Id", globalData.$data.$deviceId);
    req.headers.set("App-Version", globalData.$data.$appVersion);
    req.headers.set("App-Name", globalData.$data.$appName);
    req.headers.set("App-Mode", `${globalData.$data.$appMode}`);
    req.headers.set("App-Code", `${globalData.$data.$appCode}`);

    // return response callback
    return function (resp) {
        if (resp.status === 0) {
            this.$router.push({
                name: "domainSetup"
            });
            return
        }

        if (resp.status === 409 || resp.status === 406) {
            clearLocalStorage();
            // this.$store.commit("checkAppUpdate");
            this.$router.push({
                name: "login",
                params: {
                    hasError: true,
                    errorMsg: resp.body.message
                }
            });
            return;
        }
    };
});


new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')